// Entry point for the build script in your package.json
import '@hotwired/turbo-rails';
import './controllers';
import { preserveFocusAcrossStreams } from './utils/preserve_focus_across_streams';
import { deferPlanningFormWhileAnnexesOpen } from './utils/defer_planning_form_while_annexes_open';
import { installWebVitalsBeacon } from './utils/web_vitals_beacon';
import { silenceTurboFetchErrorsOnUnload } from './utils/turbo_unload_fetch_errors';

// Mesures LCP / INP / CLS d'un échantillon de pages de l'app connectée, pour les faits de perf nocturnes.
// Inerte sans la balise meta `web-vitals` (posée par le seul layout de l'app connectée).
installWebVitalsBeacon();

// Quitter la page pendant le chargement d'une frame (« Chargement du planning… ») ne
// laisse plus de `TypeError: Failed to fetch` en console (QA E1, PR #904).
silenceTurboFetchErrorsOnUnload();

// Un remplacement Turbo Stream ne fait jamais perdre le focus clavier (PR #731, F10).
preserveFocusAcrossStreams();
// Une diffusion ne remplace pas le formulaire planning de la modale des annexes
// du CR pendant qu'elle est ouverte : différé à sa fermeture (PR #731, revue #4).
// Installé APRÈS la préservation du focus : il enveloppe donc le rendu déjà
// enveloppé, et le rendu différé relit le focus au moment où il est joué.
deferPlanningFormWhileAnnexesOpen();

const ONBOARDING_SCROLL_RESTORE_KEY = 'onboarding:scroll-restore';
const ONBOARDING_SCROLL_RESTORE_TTL_MS = 15_000;
const PORTAL_SCROLL_ANCHOR_KEY = 'portal:scroll-anchor';

function restoreOnboardingScrollPosition() {
  let storedPosition = null;

  try {
    storedPosition = sessionStorage.getItem(ONBOARDING_SCROLL_RESTORE_KEY);
  } catch {
    return;
  }

  if (!storedPosition) {
    return;
  }

  try {
    const parsed = JSON.parse(storedPosition);
    const scrollY = Number(parsed.y);
    const isFresh = Date.now() - Number(parsed.timestamp) < ONBOARDING_SCROLL_RESTORE_TTL_MS;
    const samePath = parsed.path === window.location.pathname;
    const isValid = Number.isFinite(scrollY) && scrollY >= 0;

    try {
      sessionStorage.removeItem(ONBOARDING_SCROLL_RESTORE_KEY);
    } catch {
      // Ignore if storage is unavailable.
    }

    if (!isFresh || !samePath || !isValid) {
      return;
    }

    requestAnimationFrame(() => {
      window.scrollTo({ top: scrollY, behavior: 'auto' });
    });
  } catch {
    try {
      sessionStorage.removeItem(ONBOARDING_SCROLL_RESTORE_KEY);
    } catch {
      // Ignore if storage is unavailable.
    }
  }
}

function restorePortalScrollAnchor() {
  let anchor = null;
  try {
    anchor = sessionStorage.getItem(PORTAL_SCROLL_ANCHOR_KEY);
    sessionStorage.removeItem(PORTAL_SCROLL_ANCHOR_KEY);
  } catch {
    return;
  }
  if (!anchor) return;
  requestAnimationFrame(() => {
    const el = document.getElementById(anchor);
    if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' });
  });
}

// Désactiver le scroll (molette) sur les inputs number
// Empêche l'incrémentation/décrémentation involontaire des valeurs
document.addEventListener('turbo:load', () => {
  restoreOnboardingScrollPosition();
  restorePortalScrollAnchor();

  document.addEventListener(
    'wheel',
    (e) => {
      if (e.target.type === 'number') {
        e.preventDefault();
      }
    },
    { passive: false }
  );
});
